import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ErrorHandlingService } from '../../../services/error-handling/error-handling.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SpinnerService } from '../../../services/spinner';
import { Observable, of } from 'rxjs';
import { HttpHeaderConstants } from '../../../services/http-header.constant';
import { catchError, finalize } from 'rxjs/operators';
import { AlertSubscription } from '../../../models/appcloud/alert/alert-subscription.model';
import { AlertSubscriptionSearch } from '../../../models/appcloud/alert/alert-subscription-search.model';

@Injectable({
    providedIn: 'root',
})
export class AlertSubscriptionService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private ALERT_SUBSCRIPTION_URL: string = environment.publicApiHost + '/appcloud/alert-subscriptions';

    search(search: AlertSubscriptionSearch, additionalHeaders: any = {}): Observable<AlertSubscription[]> {
        this.#spinnerService.addProcess('AlertSubscriptionService.search', 'Searching for you alert subscriptions...');
        const httpOptions = {
            headers: new HttpHeaders({
                ...HttpHeaderConstants.defaultHeaders,
                ...additionalHeaders,
            }),
            params: new HttpParams(),
        };

        for (const [key, value] of Object.entries(search)) {
            httpOptions.params = httpOptions.params.set(key, value);
        }

        return this.#http.get<AlertSubscription[]>(this.ALERT_SUBSCRIPTION_URL, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while searching for your alert subscriptions. Please try again later.'
                );
                return of<AlertSubscription[]>();
            }),
            finalize(() => {
                this.#spinnerService.completeProcess('AlertSubscriptionService.search');
            })
        );
    }

    delete(id: number, additionalHeaders: any = {}): Observable<any> {
        this.#spinnerService.addProcess('AlertSubscriptionService.delete.' + id, 'Deleting your alert subscription...');

        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };

        return this.#http.delete<Observable<any>>(`${this.ALERT_SUBSCRIPTION_URL}/${id}`, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while deleting your alert subscription. Try again later.'
                );
                return of<Observable<any>>();
            }),
            finalize(() => this.#spinnerService.completeProcess('AlertSubscriptionService.delete.' + id))
        );
    }
}
